import React from 'react';

import { QAlityFreeTextExecutionDetails } from '@qality/common-components/src/molecules/QAlityFreeTextExecutionDetails';
import { PreviousTestExecutionsHeader } from '@qality/common-components/src/organisms/PreviousTestExecutions';

type Props = { issueKey: string };

export const QAlityFreePreviousTestExecutions = ({
  issueKey,
}: Props): JSX.Element => {
  return (
    <PreviousTestExecutionsHeader
      title='Past executions'
      testExecutionDetails={
        <QAlityFreeTextExecutionDetails issueKey={issueKey} />
      }
    />
  );
};
